/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCouponHistoryRespVo
 */
export interface UserCouponHistoryRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof UserCouponHistoryRespVo
     */
    id?: number;
    /**
     * 用户的优惠券 ID，关联用户优惠券表主键
     * @type {number}
     * @memberof UserCouponHistoryRespVo
     */
    userCouponId?: number;
    /**
     * 本次操作的优惠券数量
     * @type {number}
     * @memberof UserCouponHistoryRespVo
     */
    number?: number;
    /**
     * 操作前的优惠券余额数量
     * @type {number}
     * @memberof UserCouponHistoryRespVo
     */
    principal?: number;
    /**
     * 备注说明，记录操作原因或说明信息
     * @type {string}
     * @memberof UserCouponHistoryRespVo
     */
    remark?: string;
    /**
     * 用户 ID，关联用户表主键
     * @type {number}
     * @memberof UserCouponHistoryRespVo
     */
    userId?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserCouponHistoryRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof UserCouponHistoryRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof UserCouponHistoryRespVo
     */
    updateTime?: string;
    /**
     * 优惠券进出类型：0-出优惠券（扣减），1-进优惠券（增加）
     * @type {number}
     * @memberof UserCouponHistoryRespVo
     */
    intOutType?: number;
    /**
     * 优惠券名称
     * @type {string}
     * @memberof UserCouponHistoryRespVo
     */
    couponName?: string;
    /**
     * 用户账号
     * @type {string}
     * @memberof UserCouponHistoryRespVo
     */
    account?: string;
    /**
     * 用户名
     * @type {string}
     * @memberof UserCouponHistoryRespVo
     */
    userName?: string;
}

/**
 * Check if a given object implements the UserCouponHistoryRespVo interface.
 */
export function instanceOfUserCouponHistoryRespVo(value: object): value is UserCouponHistoryRespVo {
    return true;
}

export function UserCouponHistoryRespVoFromJSON(json: any): UserCouponHistoryRespVo {
    return UserCouponHistoryRespVoFromJSONTyped(json, false);
}

export function UserCouponHistoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCouponHistoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userCouponId': json['userCouponId'] == null ? undefined : json['userCouponId'],
        'number': json['number'] == null ? undefined : json['number'],
        'principal': json['principal'] == null ? undefined : json['principal'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'intOutType': json['intOutType'] == null ? undefined : json['intOutType'],
        'couponName': json['couponName'] == null ? undefined : json['couponName'],
        'account': json['account'] == null ? undefined : json['account'],
        'userName': json['UserName'] == null ? undefined : json['UserName'],
    };
}

export function UserCouponHistoryRespVoToJSON(json: any): UserCouponHistoryRespVo {
    return UserCouponHistoryRespVoToJSONTyped(json, false);
}

export function UserCouponHistoryRespVoToJSONTyped(value?: UserCouponHistoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userCouponId': value['userCouponId'],
        'number': value['number'],
        'principal': value['principal'],
        'remark': value['remark'],
        'userId': value['userId'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'intOutType': value['intOutType'],
        'couponName': value['couponName'],
        'account': value['account'],
        'UserName': value['userName'],
    };
}

